var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "site-list-component" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: { paths: [{ title: _vm.$t("message.sites") }], select: true },
        },
        [
          _c(
            "a-button",
            {
              staticClass: "ml-2 actionButtonBreadcrumb",
              on: {
                click: function ($event) {
                  return _vm.$router.push("/sites")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("adminPanel.sitesOldUi")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "route-page-content breadcrumb-content" },
        [
          _c("SidebarChild", {
            attrs: { items: _vm.menuItems, focusActive: true },
            on: { selected: _vm.handleSidebarSelection },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "position-relative pt-3 content-wrapper" }, [
            _c(
              "div",
              { staticClass: "toolbar-container" },
              [
                _c("SiteFilterToolbar", {
                  ref: "filterToolbar",
                  model: {
                    value: _vm.filters,
                    callback: function ($$v) {
                      _vm.filters = $$v
                    },
                    expression: "filters",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c(
                      "SupsisButton",
                      { attrs: { warning: "" }, on: { click: _vm.updateView } },
                      [
                        _vm._v(
                          " ❗ " + _vm._s(_vm.$t("adminPanel.sitesUpdateView"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.refreshData },
                      },
                      [
                        _c("small", { staticClass: "keyboard-shortcut" }, [
                          _vm._v(
                            _vm._s(_vm.$t("adminPanel.sitesShortcutOptionR"))
                          ),
                        ]),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("message.refresh")) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.openColumnSettings },
                      },
                      [
                        _c("small", { staticClass: "keyboard-shortcut" }, [
                          _vm._v(
                            _vm._s(_vm.$t("adminPanel.sitesShortcutOptionC"))
                          ),
                        ]),
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("adminPanel.sitesTableSettings")) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "" },
                        on: { click: _vm.downloadAsExcel },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("adminPanel.sitesDownloadExcel")) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.checkboxOption.selectedRowKeys.length > 0
              ? _c(
                  "div",
                  { staticClass: "bulk-action-bar" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "danger" },
                        on: { click: _vm.bulkDelete },
                      },
                      [_vm._v(_vm._s(_vm.$t("adminPanel.sitesBulkDelete")))]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.bulkDeleteProgress
              ? _c(
                  "div",
                  { staticClass: "progress-bar" },
                  [
                    _c("a-progress", {
                      attrs: { percent: _vm.bulkDeleteProgress },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-wrapper" },
              [
                _c("supsis-table", {
                  attrs: {
                    columns: _vm.columns(),
                    rows: _vm.sites,
                    "bottom-pagination": true,
                    "pagination-cursor": _vm.paginationCursor,
                    options: {
                      eventCustomOption: _vm.eventCustomOption,
                      checkboxOption: _vm.checkboxOption,
                    },
                    id: "site-list-table",
                    "empty-text": _vm.$t("adminPanel.sitesTableEmptyText"),
                  },
                  on: { "cursor-changed": _vm.onCursorChanged },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isColumnSettingsModalVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("ticket.columnSettings"),
                showFooter: false,
                id: "site-list-column-settings",
              },
              on: { cancel: _vm.closeColumnSettings },
            },
            [
              _c("SiteColumnSelector", {
                attrs: {
                  "selected-columns": _vm.selectedColumns,
                  "all-columns": _vm.allColumns,
                },
                on: {
                  save: _vm.saveColumnSettings,
                  cancel: _vm.closeColumnSettings,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }